"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _cond = _interopRequireDefault(require("lodash/fp/cond"));

var _find = _interopRequireDefault(require("lodash/fp/find"));

var findW1 = (0, _find.default)(function (d) {
  return d.warehouse === '1';
});
var findW2 = (0, _find.default)(function (d) {
  return d.warehouse === '2';
});
var mapStockDetail = (0, _cond.default)([[function (d) {
  return (findW1(d) || {}).state === 'stock';
}, function () {
  return 'https://schema.org/InStock';
}], [function (d) {
  return (findW2(d) || {}).state === 'stock';
}, function () {
  return 'https://schema.org/PreOrder';
}], [function (d) {
  return (findW1(d) || {}).state === 'to-order';
}, function () {
  return 'https://schema.org/PreOrder';
}], [function () {
  return true;
}, function () {
  return 'https://schema.org/OutOfStock';
}]]);
module.exports = mapStockDetail;